import { render, staticRenderFns } from "./MakeRemark.vue?vue&type=template&id=f0891f80&scoped=true&"
import script from "./MakeRemark.vue?vue&type=script&lang=js&"
export * from "./MakeRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0891f80",
  null
  
)

export default component.exports